import styled from "styled-components";

export const EmailInputContainer = styled.div`
    
    @media (max-width: 399.98px) { 
        width: 80%
    }

     @media (min-width: 400px) and (max-width: 575.98px) { 
        width: 83%
    }


    @media (min-width: 576px) and (max-width: 767.98px) { 
        width: 87%
    }


    @media (min-width: 768px) and (max-width: 991.98px) { 
        width: 87%
    }


    @media (min-width: 992px) and (max-width: 1199.98px) { 
        width: 84%
    }


    @media (min-width: 1200px) { 
        width: 84%
    }
`